import React, { createContext, useRef, useContext, useEffect } from 'react';
import { useStore } from 'zustand';

import { IUseLayerDashboardStore, createLayerDashboardTabStore, LayerDashboardTabStore } from '../stores/useLayerDashboardStore';

const LayerDashboardContext = createContext<LayerDashboardTabStore | undefined>(undefined);

export const LayerDashboardTabProvider = ({ children, tabsAlreadyRendered, index, display }: { children: React.ReactNode; tabsAlreadyRendered?: number[]; index?: number; display?: boolean }) => {
    const storeRef = useRef<LayerDashboardTabStore>();

    if (!storeRef.current) {
        storeRef.current = createLayerDashboardTabStore();
    }

    return (
        <LayerDashboardContext.Provider value={storeRef.current}>
            {(index !== undefined && tabsAlreadyRendered?.includes(index)) &&
                <div style={{ display: display ? 'flex' : 'none' }}>
                    {children}
                </div>
            }
        </LayerDashboardContext.Provider>
    );
};

export const useLayerDashboardTabStore = <T,>(selector: (state: IUseLayerDashboardStore) => T): T => {
    const store = useContext(LayerDashboardContext);
    if (!store) {
        throw new Error('useLayerDashboardTabStore must be used within a LayerDashboardTabProvider');
    }

    return useStore(store, selector);
};